export const colors = {
  dark:       "#050e08",
  darkCard:   "rgba(13, 31, 20, 0.75)",
  cardBorder: "rgba(200, 241, 53, 0.18)",
  mid:        "#10b981",
  lime:       "#c8f135",
  cyan:       "#06b6d4",
  pale:       "rgba(200, 241, 53, 0.12)",
  white:      "#f8fafc",
  gray:       "#94a3b8",
  bg:         "#07140b",
  footer:     "#030a05",
};

export const fonts = {
  display: "'Plus Jakarta Sans', 'Outfit', sans-serif",
  body:    "'Plus Jakarta Sans', sans-serif",
};

export const radius = {
  pill: 9999,
  card: 24,
  lg:   32,
};
